import { getAngularService, AngularServices, } from '../../core/helpers/get-angular-service';
export const checkForSsoRequest = () => (dispatch) => {
    const $location = getAngularService(AngularServices.Location);
    const path = $location.path();
    const params = $location.search();
    if (params.sso && path === '/sign-in') {
        dispatch({
            type: 'SSO/ADD_SSO_REQUEST',
            payload: params,
        });
    }
};
export const getRedirectUrl = async (ssoRequest) => {
    const api = getAngularService(AngularServices.SsoServiceApi);
    const spName = ssoRequest.sso;
    const params = { ...ssoRequest };
    delete params.sso;
    const { url } = await api.getRedirectUrl({ spName, ...params }).$promise;
    return url;
};
